import React, { Component, Fragment } from 'react';
import { SITE_ORIGIN } from 'constants/site';
import { SAILTHRU_CUSTOMER_ID } from 'constants/vendor';

// Source JS (see minified below)
/*
const SCRIPT = `
  (function() {
    var s = document.createElement('script');
    s.src = 'https://ak.sail-horizon.com/spm/spm.v1.min.js';
    s.async = true;
    s.onload = function() {
      window.Sailthru.init({
        customerId: '${SAILTHRU_CUSTOMER_ID}',
        autoTrackPageview: false,
        isCustom: true
      });
      if (window._sailthru_q && window._sailthru_q.length) {
        for (var i = 0; i < window._sailthru_q.length; i++) {
          var keys = Object.keys(window._sailthru_q[i]);
          if (keys.length < 1) { continue; }
          if (['pageview', 'gdprDoNotTrack', 'cookiesDoNotTrack'].includes(keys[0])) {
            window.Sailthru.track(keys[0], window._sailthru_q[i][keys[0]]);
          } else {
            window.Sailthru.integration(keys[0], window._sailthru_q[i][keys[0]]);
          }
        }
        delete window._sailthru_q;
      }
    };
    document.head.appendChild(s);
  }());
`;
*/

// Minified JS
const SCRIPT = `!function(){var s=document.createElement("script");s.src="https://ak.sail-horizon.com/spm/spm.v1.min.js",s.async=!0,s.onload=function(){if(window.Sailthru.init({customerId:"${SAILTHRU_CUSTOMER_ID}",autoTrackPageview:!1,isCustom:!0}),window._sailthru_q&&window._sailthru_q.length){for(var i=0;i<window._sailthru_q.length;i++){var keys=Object.keys(window._sailthru_q[i]);keys.length<1||(["pageview","gdprDoNotTrack","cookiesDoNotTrack"].includes(keys[0])?window.Sailthru.track(keys[0],window._sailthru_q[i][keys[0]]):window.Sailthru.integration(keys[0],window._sailthru_q[i][keys[0]]))}delete window._sailthru_q}},document.head.appendChild(s)}();`;

class Sailthru extends Component {
  static Head() {
    if (!SAILTHRU_CUSTOMER_ID) {
      return null;
    }
    return (
      <Fragment>
        <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />
      </Fragment>
    );
  }
  render() {
    return null;
  }
}

// thin, queue-aware wrapper for manual pageview
// https://getstarted.sailthru.com/site/personalization-engine/pe-setup/
Sailthru.pageView = path => {
  if (typeof window === 'undefined' || !SAILTHRU_CUSTOMER_ID) {
    return;
  }

  const url = `${SITE_ORIGIN}${path}`;
  const payload = { url };

  if ('Sailthru' in window) {
    window.Sailthru.track('pageview', payload);
  } else {
    window._sailthru_q = window._sailthru_q || [];
    window._sailthru_q.push({ pageview: payload });
  }
};

// thin, queue-aware wrapper for userSignUp
// https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
Sailthru.addUpdateUser = (email, vars = {}) => {
  if (typeof window === 'undefined' || !SAILTHRU_CUSTOMER_ID) {
    return;
  }

  const payload = {
    email,

    // required if `source` or `lists` is not present
    vars
  };

  if ('Sailthru' in window) {
    window.Sailthru.integration('userSignUp', payload);
  } else {
    window._sailthru_q = window._sailthru_q || [];
    window._sailthru_q.push({ userSignUp: payload });
  }
};

export default Sailthru;
